/* Panthera Design System — reveal-on-scroll.
   Adds .p-in to .p-reveal elements as they enter the viewport.
   Falls back to showing everything immediately when IntersectionObserver
   is unavailable or the user prefers reduced motion. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supported = 'IntersectionObserver' in window;

  const observer = supported
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('p-in');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      )
    : null;

  const init = (root) => {
    const elements = (root || document).querySelectorAll('.p-reveal:not(.p-in)');
    elements.forEach((el) => {
      if (reduceMotion || !observer) {
        el.classList.add('p-in');
      } else {
        observer.observe(el);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  /* Re-scan when sections are (re)rendered in the theme editor */
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
